import React from 'react';
import "./filter.scss";
import Dropdown from '../../common/dropdown-v2/dropdown';
import DropdownV4 from '../../common/dropdown-v4/dropdown';

import SchoolApi from '../../../apis/school'
import MasterDataApi from '../../../apis/master-data'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import 'bootstrap/dist/css/bootstrap.css'
class FilterComponent extends React.Component {

    state = {
        showShadow: false,
        showFilters: true,
        disableGo: true,

        boardsDropdownItems: [],
        classDropdownItems: [],
        chapterDropDownItems: [],
        teachersDropDownItems: [],
        selectedBoard: this.props.delegate?.props?.location?.state?.sectionDetail?.board? this.props.delegate?.props?.location?.state?.sectionDetail?.board :  "",
        selectedClass: this.props.delegate?.props?.location?.state?.sectionDetail?.class? this.props.delegate?.props?.location?.state?.sectionDetail?.class :  "",
        selectedSection : this.props.delegate?.props?.location?.state?.sectionDetail?._id? this.props.delegate?.props?.location?.state?.sectionDetail?._id :  "",
        selectedChapterKey: [],
        selectedTeachersId: [],
        eloDropdownItems: [],
        disableClass: true,
        disableChapters: true,

        statusDropdownItems: [
            { title: "Onboarded", value: "ONBOARDED" },
            { title: "Invite Sent", value: "INVITE_SENT" }
        ]

    }

    classSectionHash = {}
    conceptHash = {}
    eloHash = {}

    componentDidMount() {
        // selectedBoard: this.props.delegate?.props?.location?.state?.sectionDetail?.board? this.props.delegate?.props?.location?.state?.sectionDetail?.board :  "",
        // selectedSection : this.props.delegate?.props?.location?.state?.sectionDetail?._id? this.props.delegate?.props?.location?.state?.sectionDetail?._id :  "",
        
        // setTimeout(() => {
        // let sClass = this.props.delegate?.props?.location?.state?.sectionDetail?.class? this.props.delegate?.props?.location?.state?.sectionDetail?.class :  ""
        //     this.setState({selectedClass : sClass})
        //   }, 1000)
        
        this.getClasses()
    };

    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [], classNames = [];

                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }


                let board = ''
                if (boards.length) {
                    board = boards[0].value
                }


                classNames = classes.map( c => c.value )

                if(!this.props.delegate?.props?.location?.state) {
                    this.getSections({board, class : classNames})
                }

                if (boards.length > 1) {
                    this.setState({ boardsDropdownItems: boards })
                } else {
                    this.setState({ selectedBoard: school?.boards[0]?.name })
                }
                console.log(this.state.selectedClass)
                this.setState({ classDropdownItems: classes})
            }).catch(err => {
            })
    }

    getSections(payload = {}) {
        console.log(this.state.selectedClass)

        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        if (!payload.class || !payload.board) {
            this.setState({ sectionDropdownItems: [], selectedSection: "" })
            this.reloadDropdown()
            return
        }

        SchoolApi.getSections(payload)
            .then(response => {
                console.log(response)
                let sections = []
                for (let i = 0; i < response.response.length; i++) {

                    if (!response.response[i].noSectionInClass) {
                        sections.push({
                            title: response.response[i].section,
                            value: response.response[i]._id,
                        })
                    }
                }
                this.classSectionHash[payload.class] = sections
                this.setState({ sectionDropdownItems: sections, selectedSection: "", unAssignedUsersCount : response.unAssignedUsers, noSectionInClassUsersCount : response.noSectionInClassUsersCount })
                this.reloadDropdown()
            }).catch(err => {
                this.setState({ sectionDropdownItems: [], selectedSection: "" })
                this.reloadDropdown()
            })
    }

    getChapters(payload = {}) {

        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = this.state.selectedBoard

        MasterDataApi.getChapterList(payload)
            .then(response => {
                let chapters = []
                response = response.data
                this.setState({ masterDataId: response._id })
                for (let i = 0; i < response.chapters.length; i++) {
                    let chapter = response.chapters[i], concepts = []
                    chapters.push({
                        title: chapter.title,
                        value: chapter.key,
                    })

                    for (let j = 0; j < chapter.concepts?.length; j++) {
                        let concept = chapter.concepts[j]
                        concepts.push({
                            title: concept.title,
                            value: concept.key,
                            order: j + 1
                        })
                        // this.buildElosDropdown(concept)
                    }

                    this.conceptHash[chapter.key] = concepts
                }

                // chapters.push({value:'ALL',title:'ALL'})
                this.setState({ chapterDropDownItems: chapters, selectedChapter: "" })
                this.reloadDropdown()
            }).catch(err => {
            })
    }

    sortPayload(nodes) {
        let orderedList = [];
        let workFlowNodeHash = {};
        let startingNode;

        for (let i = 0; i < nodes.length; i++) {

            let nodeId = nodes[i]._id.toString();

            if (nodes[i].previousNode == null)
                startingNode = nodeId;

            workFlowNodeHash[nodeId] = nodes[i];
        }

        let tempNode = startingNode;

        for (let i = 0; i < nodes.length; i++) {
            if (tempNode) {
                orderedList.push(workFlowNodeHash[tempNode]);
                tempNode = workFlowNodeHash[tempNode].nextNode;
            }
        }
        return orderedList
    }


    getWorkflowNodes(payload = {}) {
        payload = {
            class: this.state.selectedClass,
            board: this.state.selectedBoard,
            chapterKey: this.state.selectedChapter,
            masterDataId: this.state.masterDataId
        }
        MasterDataApi.getWorkflowNodes(payload)
            .then(response => {
                response = response.data
                for (let i = 0; i < response.length; i++) {
                    let chapter = response[i], elos = []

                    for (let j = 0; j < chapter.elos?.length; j++) {
                        let elo = chapter.elos[j]
                        elos.push({
                            title: elo.title,
                            value: elo.id,
                            conceptTitle: chapter.conceptTitle,
                            conceptValue: chapter.conceptKey
                        })
                    }
                    if (this.eloHash[chapter.conceptKey]) {
                        this.eloHash[chapter.conceptKey].push(...elos)
                    } else {
                        this.eloHash[chapter.conceptKey] = elos
                    }
                }

                let eloList = this.sortPayload(response)
                this.setState({ orderedEloList: eloList })
            }).catch(err => {
            })
    }

    buildElosDropdown(concept) {
        let elos = []
        for (let i = 0; i < concept?.subConcepts?.length; i++) {
            let subConcept = concept.subConcepts[i]
            for (let j = 0; j < subConcept.elo?.length; j++) {
                let elo = subConcept.elo[j]
                elos.push({
                    title: elo.title,
                    value: elo.eloId,
                    conceptTitle: concept.title,
                    conceptValue: concept.key
                })
            }

        }
        this.eloHash[concept.key] = elos
        return
    }

    reloadDropdown() {
        this.setState({ reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }

    resetDropDowns(callback) {
        this.setState({
            selectedBoardId: "",
            selectedClassId: "",
            chapterDropdownItems: [],
        }, () => { if (callback) callback(); });
    }


    onGo() {
        let payload = {
            board: this.state.selectedBoard,
            class: this.state.selectedClass,
            chapterKey: this.state.selectedChapterKey,
            assignedTo: this.state.selectedTeachersId
        };
        if (this.props.onGo) {
            this.props.onGo(payload)
        }
    }

    refreshPage() {
        this.setState(
            { reload: true },
            () => this.setState({ reload: false })
        )
    }

    toggleFilters = () => {
        this.setState({ showFilters: !this.state.showFilters })
    }

    onSelectDropDown = (option, key, cb) => {
        this.setState({ [key]: option?.value, [`${key}Object`]: option }, () => {
            if (cb) cb()
            if (key == "selectedClass" || key == "selectedBoard") {
                console.log(this.state.selectedClass)
                this.getSections()
                this.getChapters()
            }

            if (key == "selectedChapter") {
                if (option?.value) {
                    this.getWorkflowNodes()

                    let concepts = this.conceptHash[option?.value]
                    // concepts.push({title:'ALL',value:'ALL'})
                    this.setState({ conceptDropownItems: concepts, reloadConceptDropdown: true }, () => {
                        this.setState({ reloadConceptDropdown: false })
                    })
                } else {

                    this.setState({ conceptDropownItems: [], reloadConceptDropdown: true }, () => {
                        this.setState({ reloadConceptDropdown: false })
                    })
                }
                this.reloadDropdown()
            }

        })
    }

    onMultiSelectDropdown = (options, key) => {
        let value = [], eloDropdownItems = []
        options = options.sort((a, b) => a.order - b.order)
        for (let i = 0; i < options.length; i++) {
            let option = options[i]
            value.push(option?.value)

            if (key == "selectedConcept") {
                if (this.eloHash[option?.value]) {

                    let elo = this.eloHash[option?.value]
                    let elos = elo.map((e) => {
                        return {
                            ...e,
                            conceptName: `Concept ${i + 1}`
                        }
                    })
                    eloDropdownItems.push(...elos)
                }
            }
        }
        this.setState({ reloadDropdown: true, eloDropdownItems, [key]: value, [`${key}Object`]: options }, () => {
            this.setState({ reloadDropdown: false })
        })
    }


    onSelectElo = (options) => {
        let values = options.map(option => option?.value)
        let result = []
        for (let i = 0; i < this.state.orderedEloList?.length; i++) {
            let eloId = this.state.orderedEloList[i]?.elos[0]?.id
            if (values.includes(eloId)) {
                result.push(eloId)
            }
        }

        this.setState({ selectedElo: result, selectedEloObject: options }, () => {
        })
    }

    handleCreatedDateEvent = (event, picker) => {
        // this.createdStartDate = new Date(picker.startDate);
        // this.createdEndDate = new Date(picker.endDate);

        this.createdDateRangeStart = new Date(picker.startDate);
        this.createdDateRangeEnd = new Date(picker.endDate).toLocaleDateString() == new Date().toLocaleDateString() ? new Date() : new Date(picker.endDate);

        this.setState({ createdDate: this.createdDateRangeStart.toLocaleDateString(), selectedCreatedDateRange: this.createdDateRangeStart.toLocaleDateString() + "  -  " + this.createdDateRangeEnd.toLocaleDateString() });
    }

    handleDueDateEvent = (event, picker) => {
        this.dueDateRangeStart = new Date(picker.startDate);
        this.dueDateRangeEnd = new Date(picker.endDate).toLocaleDateString() == new Date().toLocaleDateString() ? (new Date(new Date().setHours(23, 59, 59, 999)).toISOString()).slice(0, -1) : (new Date(new Date(picker.endDate).setHours(23, 59, 59, 999)).toISOString()).slice(0, -1);

        this.setState({ dueDate: new Date(this.dueDateRangeStart).toLocaleDateString(), selectedDueDateRange: new Date(this.dueDateRangeStart).toLocaleDateString() + "  -  " + new Date(this.dueDateRangeEnd).toLocaleDateString() });
    }


    onClickGo = (callback) => {

        let payload = {}
        if (this.state.selectedBoard) {
            payload.board = this.state.selectedBoard
        }
        if (this.state.selectedClass) {
            payload.class = this.state.selectedClass
        }
        if (this.state.selectedSection) {
            payload.sectionId = this.state.selectedSection
        }
        if (this.state.search) {
            payload.search = this.state.search
        }
        if (this.state.selectedStatus) {
            payload.status = this.state.selectedStatus
        }
        if (this.state.selectedSchoolApprovalStatus) {
            payload.schoolApprovalStatus = this.state.selectedSchoolApprovalStatus
        }
        if (this.props.delegate.onFilterGo) {
            this.props.delegate.onFilterGo(payload, callback)
        }
    }

    clearFilter = () => {
        this.getClasses()
        this.setState({
            selectedBoard: "",
            selectedClass: "",
            selectedSection: "",
            search: "",
            selectedStatus: ""
        }, () => {
            this.refreshPage()
            if (this.props.delegate.onFilterGo) {
                this.props.delegate.onFilterGo()
            }
        })

    }

    refreshPage() {
        this.setState(
            { reload: true },
            () => this.setState({ reload: false })
        )
    }

    onChangeHandler(event, key) {
        let value = event.target.value
        this.setState({ [key]: value })
    }


    render() {

        return (

            <div className="student-filter">
                <div className="filter-header" >
                    <div className="d-inline" onClick={this.toggleFilters}>
                        <div className="filter-title d-inline">{"Filters"}</div>
                        <div className="d-inline"><i class={this.state.showFilters ? "filter-arrow up" : "filter-arrow down"}></i></div>
                    </div>
                </div>
                {
                    !this.state.reload ?
                        <div className={this.state.showFilters ? "filter-content" : "filter-content d-none"} >
                            <div className="row">
                                {
                                    this.state.boardsDropdownItems.length > 1 ?
                                        <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                            <div className="filter-input-label">
                                                Board
                                            </div>
                                            <div>
                                                <Dropdown
                                                    placeholder='Select a board'
                                                    options={this.state.boardsDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedBoard")}
                                                    text={"title"}
                                                    value={this.state.selectedBoard}
                                                />
                                            </div>
                                        </div>
                                        : ""
                                }
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Class
                                    </div>
                                    <div>
                                        <Dropdown
                                            placeholder='Select a Class'
                                            options={this.state.classDropdownItems}
                                            onSelect={(option) => this.onSelectDropDown(option, "selectedClass")}
                                            text={"title"}
                                            value={this.state.selectedClass}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Section
                                    </div>
                                    <div>
                                        {
                                            !this.state.reloadDropdown ?
                                                <Dropdown
                                                    key="class"
                                                    multiSelect
                                                    placeholder='Select a Section'
                                                    options={this.state.sectionDropdownItems}
                                                    onSelect={(option) => this.onMultiSelectDropdown(option, "selectedSection")}
                                                    text={"title"}
                                                    value={this.state.selectedSection}
                                                >
                                                </Dropdown>
                                                : ""
                                        }
                                    </div>
                                </div>

                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Status
                                    </div>
                                    <div>
                                        {
                                            !this.state.reloadDropdown ?
                                                <Dropdown
                                                    key="status"
                                                    placeholder='Select a Status'
                                                    options={this.state.statusDropdownItems}
                                                    onSelect={(option) => this.onSelectDropDown(option, "selectedStatus")}
                                                    text={"title"}
                                                    value={this.state.selectedStatus}
                                                >
                                                </Dropdown>
                                                : ""
                                        }
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12 pt-4">
                                    <div className="filter-input-label">
                                        Search
                                    </div>
                                    <div>
                                        <input className="cw-input" value={this.state.search} onChange={(event) => this.onChangeHandler(event, "search")} placeholder='Search by Name' />
                                    </div>
                                </div>

                                <div className="col ml-2 filter-buttons">
                                    <div className="filter-button  d-inline-block">
                                        <button className={`cw-button`} onClick={this.onClickGo.bind(this)}>{"GO"}</button>
                                    </div>
                                    <div className="filter-button ml-3 d-inline-block">
                                        <button className={`cw-button clear-btn`} onClick={this.clearFilter.bind(this)}>{"CLEAR"}</button>
                                    </div>
                                </div>
                                <div className="col  text-right assign-section">
                                    <div className="filter-button">
                                        <button className={`cw-btn-sm cw-btn-primary assign-section-btn`} onClick={this.props.onAssignSection}>{"ASSIGN SECTION"}</button>
                                        {this.state.unAssignedUsersCount ? <div className={`mt-1 un-assigned-text ${this.state.selectedClass ? 'margin-1' : 'margin-2'}`}>{this.state.unAssignedUsersCount - this.state.noSectionInClassUsersCount} Student(s) {` ${this.state.selectedClass ? 'from ' + this.state.selectedClass : ''}`} have no Section Assigned</div> : '' }
                                    </div>
                                    
                                </div>
                            </div>
                        </div> : ""

                }
            </div>


        );
    }

}

export default FilterComponent;